import { AspectRatio, Skeleton } from '@chakra-ui/react';
import Image from 'next/image';
import { useState } from 'react';

const border = ['4px solid', '4px solid', '6px solid'];
const defaultBorderColor = 'transparent !important';
const selectedBorderColor = 'red.400 !important';
const defaultAvatarMinWidth = '80px';
const defaultAvatarWidth = 80;

const Avatar = (props) => {
  const { agent, index, selectedIndex, setSelectedIndex, playingIndex, selectedAvatarRef } = props;

  const [imageLoaded, setImageLoaded] = useState(false);

  const isSelected = index === selectedIndex;

  return (
    <AspectRatio
      ratio={1}
      ref={isSelected ? selectedAvatarRef : null}
      key={index}
      width={defaultAvatarMinWidth}
      minW={defaultAvatarMinWidth}
      h={defaultAvatarMinWidth}
      mr={[4, 4, 6, 6]}
      outline={border}
      outlineColor={isSelected ? selectedBorderColor : defaultBorderColor}
      transition="outline 0.2s ease-in-out"
      cursor="pointer"
      onClick={() => setSelectedIndex(index)}
    >
      <Skeleton isLoaded={imageLoaded}>
        <Image
          onLoadingComplete={() => {
            setImageLoaded(true);
          }}
          width={defaultAvatarWidth}
          height={defaultAvatarWidth}
          src={agent.info.image}
          alt={`${agent.info.name} Headshot`}
        />
      </Skeleton>
    </AspectRatio>
  );
};

export default Avatar;
